import { ICleanStoreAction } from 'store/reducers/types';

export enum ESettingsKey {
  AccountSettings = 'accountSettings',
  PolicySettings = 'policySettings',
  StoreSettings = 'storeSettings',
  PaymentsSettings = 'paymentsSettings',
}

export enum ESettingsActions {
  GET_SETTINGS = 'GET_SETTINGS',
  GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS',
  GET_SETTINGS_FAILURE = 'GET_SETTINGS_FAILURE',
  UPDATE_SETTINGS = 'UPDATE_SETTINGS',
}

export enum EPaymentsFrequency {
  Week = 'week',
  TwoWeeks = 'two_weeks',
  ThreeWeeks = 'three_weeks',
  Month = 'month',
}

export interface IAccountSettings {
  isLoading: boolean;
  isUpdated: boolean;
  id: string;
  fullName: string;
  email: string;
  establishmentDate: string;
  website: string;
  skuAmount: string;
  discount: number;
  hasDiscount: true;
  productSources: number[];
  manufactureCountries: number[];
  sellingCountries: number[];
  autoTransferThreshold: number;
  paymentsFrequency: EPaymentsFrequency;
  lastPaymentDate: string,
  meta: {
    pendingOrdersSum: number,
    paidOrdersSum: number,
    unpaidOrdersSum: number,
    isStoreConnected: boolean,
    isVerificationNeeded: boolean,
    isPaymentDetailsConnected: boolean,
    upcomingPaymentDate: string,
    isLogoInvoiceAllowed: boolean,
    productsSyncDate: string,
  };
}

export interface IPolicyShippingCountries {
  add: number[];
  remove: number[];
}

export interface IPolicyShipping {
  id: number;
  isAllowed: boolean;
  processingTimeId: number;
  price: number;
  countryName: string;
  fullCountryName: string;
}

export interface IPolicySettings {
  isLoading: boolean;
  isUpdated: boolean;
  restrictedMarketplaces: IPolicyShippingCountries;
  paysForShippingId: number;
  returnWindowTimeId: number;
  returnsDescription: string;
  isReturnApprove: boolean;
  shipFromCountries: IPolicyShippingCountries;
  userName: string;
  processingTimeId: number;
  excludedShippingCountries: IPolicyShippingCountries;
  shipping: IPolicyShipping[];
  discount: number,
  hasDiscount: boolean,
  mapPercent: number,
  isMapPercent: boolean,
  RestrictedMarketplaceIds: number[],
}

export interface IStoreSettings {
  isLoading: boolean,
  isConnectingStore: boolean,
  isUpdated: boolean;
  id: number,
  userId: number,
  category: string,
  categoryName: string,
  description: string,
  logoUrl: string,
  name: string,
  url: string,
  productsSyncDate: string,
  isLogoInvoiceAllowed: boolean,
}

export interface IPaymentsSettings {
  isLoading: boolean;
  isUpdated: boolean;
  countryId: number;
  accountNumber: string;
  accountHolderName: string;
  accountType: string;
  additionalAddress: string;
  city: string;
  mainAddress: string;
  routingNumber: string;
  zipcode: string;
}

export interface ISettingsReducer {
  [ESettingsKey.AccountSettings]: IAccountSettings;
  [ESettingsKey.PolicySettings]: IPolicySettings;
  [ESettingsKey.StoreSettings]: IStoreSettings;
  [ESettingsKey.PaymentsSettings]: IPaymentsSettings;
}

export interface IGetSettingsAction {
  type: ESettingsActions.GET_SETTINGS | ESettingsActions.GET_SETTINGS_FAILURE;
  payload: { key: ESettingsKey; [key: string]: any; };
}

export interface IGetSettingsSuccessAction {
  type: ESettingsActions.GET_SETTINGS_SUCCESS;
  payload: { key: ESettingsKey, [key: string]: any; };
}

export interface IUpdateSettingsAction {
  type: ESettingsActions.UPDATE_SETTINGS;
  payload: { key: ESettingsKey, [key: string]: any; };
}

export type SettingsActions =
  IGetSettingsAction
  | IGetSettingsSuccessAction
  | IUpdateSettingsAction
  | ICleanStoreAction

